import { CATEGORIES } from "../lib/categories";
import { useLang } from "../contexts/LanguageContext";

/**
 * Single-select chip picker for the photo genres.
 *
 * `value` is a slug string or null (= "no category"). Clicking the active
 * chip clears the selection. When a chip is active, its description shows
 * below the picker — same copy used on the /categories index and the
 * /category/:slug detail page.
 */
export default function CategoryPicker({ value, onChange, idPrefix = "cat-chip" }) {
  const { t } = useLang();
  return (
    <div className="space-y-3" data-testid="category-picker">
      <div className="flex flex-wrap gap-2">
        {CATEGORIES.map((c) => {
          const active = value === c.slug;
          return (
            <button
              type="button"
              key={c.slug}
              onClick={() => onChange(active ? null : c.slug)}
              className={`px-3 py-1.5 border font-mono text-[10px] uppercase tracking-[0.25em] transition-colors ${
                active
                  ? "border-sienna text-white bg-sienna"
                  : "border-zinc-800 text-zinc-400 hover:border-zinc-600 hover:text-zinc-200"
              }`}
              data-testid={`${idPrefix}-${c.slug}`}
              aria-pressed={active}
            >
              {t(`cat_${c.slug}`)}
            </button>
          );
        })}
      </div>
      {value && (
        <p
          className="text-zinc-500 font-light text-xs leading-relaxed pl-1"
          data-testid="category-picker-description"
        >
          {t(`cat_${value}_desc`)}
        </p>
      )}
    </div>
  );
}
